import React from "react"
import { Button, Modal } from "react-bootstrap"

export default function AlertModal({ show, close, title, body, confirm,
  bsStyle, proceedText, disabled, bsSize }) {

  return (
    <Modal show={ show } onHide={ close } bsSize={ bsSize }>

      <Modal.Header closeButton>
        <Modal.Title>{ title }</Modal.Title>
      </Modal.Header>

      <Modal.Body>{ body }</Modal.Body>

      <Modal.Footer>
        <Button onClick={ close }>{ confirm ? 'Cancel' : 'Ok' }</Button>
        { confirm 
        ? <Button onClick={ confirm } bsStyle={ bsStyle } disabled={ !!disabled }>
            { proceedText }
          </Button>
        : null }
      </Modal.Footer>
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./src/components/fragments/AlertModal.js